module.exports = __webpack_public_path__ + "assets/img/returnBtn-ed435513.png";